var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authority"},[_c('el-tree',{ref:"authorityTree",attrs:{"data":_vm.authorityTree,"show-checkbox":"","node-key":"id","check-strictly":_vm.strictly,"props":_vm.defaultProps},on:{"check-change":_vm.changeCheck}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }